import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import OrderProductsFilter from "./filterBySkuOrProductName";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import {
  calculateTotalPaid,
  calculateTotalSum,
  calculateTotalSumOrderProducts,
  formatNumber,
  paymentLists,
  statues,
} from "../../utils/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Box,
  Button,
  Menu,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Autocomplete,
  Paper,
  Pagination,
  Select,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import Admin from "../../components/auth/Admin";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Customer from "../../actions/customer";
import Order from "../../actions/order";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import Notification from "../../components/customHelpers/Notification";
import { getTimestamp } from "../../utils/utils";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const initialHeadCells = [
  { id: "customer", label: "Customer", isVisible: true },
  { id: "quantity", label: "Item Count", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "paid", label: "Paid", isVisible: true },
  { id: "unpaid", label: "Balance", isVisible: true },
  { id: "date", label: "Date", isVisible: true },
  { id: "status", label: "Status", isVisible: true },
];

const SalesReport = () => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllOrdersWithPages, viewAllPriceOrders } = Order();
  const [customers, setCustomers] = useState([]);
  const { viewAllCustomers } = Customer();
  const [orders, setOrders] = useState([]);
  const [orderProducts, setOrderProducts] = useState([]);
  const [totalsLoading, setTotalsLoading] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [totals, setTotals] = useState({
    totalPrice: 0,
    totalPaid: 0,
    totalBalance: 0,
    isClick: true,
  });
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(orders, initialHeadCells, filterFn);

  const [headCells, setHeadCells] = useState(initialHeadCells);

  useEffect(() => {
    getAllOrders();
  }, [page, limit, searchQuery, selectedCustomer, selectedStatus]);
  useEffect(() => {
    getAllCustomers();
    getTotalPrice();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedCustomer, selectedStatus]);
  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
      }
    });
  };
  const getTotalPrice = () => {
    viewAllPriceOrders(selectedCustomer?.fullName, selectedStatus).then(
      (data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.totals) {
          setTotals({
            totalPrice: data.totals.totalPrice,
            totalPaid: data.totals.totalPaid,
            totalBalance: data.totals.totalBalance,
            isClick: true,
          });
        }
      }
    );
  };
  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewAllOrdersWithPages(
      page,
      limit,
      searchQuery,
      selectedCustomer?.fullName,
      selectedStatus
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const result = data.orders.filter(
          (order) => order.orderProducts.length > 0
        );
        setOrders(result);
        setOrderProducts(result);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };

  const handleCustomerChange = (value) => {
    setPage(1)
    setSelectedCustomer(value);
    setTotals({ ...totals, isClick: true });
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setPage(1)
    setSelectedStatus(selectedStatus);
    setTotals({ ...totals, isClick: true });
  };
  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = orders.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return item.customer.fullName;
          case "quantity":
            return item.orderProducts.length;
          case "totalPrice":
            return calculateTotalPrice(item.orderProducts);
          case "paid":
            return item.paid;
          case "unpaid":
            return calculateTotalPrice(item.orderProducts) - item.paid;
          case "date":
            return new Date(item.createdAt).toLocaleString();
          case "status":
            return item.status;
          default:
            return "";
        }
      })
    );
    const totalSum = calculateTotalSumOrderProducts(orders);
    const totalPaid = calculateTotalPaid(orders);
    const totalUnpaid = totalSum - totalPaid;

    dataToExport.push([""]);
    dataToExport.push(
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return "Grand Totals"; // Label in customer column
          case "totalPrice":
            return totalSum;
          case "paid":
            return totalPaid;
          case "unpaid":
            return totalUnpaid;
          default:
            return "";
        }
      })
    );
    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const totalsRowIndex = dataToExport.length; // Index after adding headers
    worksheet["!rows"] = worksheet["!rows"] || [];
    worksheet["!rows"][totalsRowIndex] = { style: { font: { bold: true } } };
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();

    const customerName = selectedCustomer
      ? selectedCustomer.fullName
      : "AllCustomers";
    const statusName = selectedStatus || "AllStatus";
    const balanceName = totalUnpaid.toFixed(2);

    const filename = `${customerName}_${statusName}_${balanceName}_Sales-report_${timestamp}.xlsx`;
    saveAs(blob, filename);
    handleMenuClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        headCells.filter((cell) => cell.isVisible).map((cell) => cell.label),
      ],
      body: orders.map((item) =>
        headCells
          .filter((cell) => cell.isVisible)
          .map((cell) => {
            switch (cell.id) {
              case "customer":
                return item.customer.fullName;
              case "quantity":
                return item.orderProducts.length;
              case "totalPrice":
                return calculateTotalPrice(item.orderProducts);
              case "paid":
                return item.paid;
              case "unpaid":
                return calculateTotalPrice(item.orderProducts) - item.paid;
              case "date":
                return new Date(item.createdAt).toLocaleString();
              case "status":
                return item.status;
              default:
                return "";
            }
          })
      ),
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });
    const totalSum = parseFloat(calculateTotalSumOrderProducts(orders));
    const totalPaid = parseFloat(calculateTotalPaid(orders));
    const totalUnpaid = totalSum - totalPaid;

    const finalY = doc.lastAutoTable.finalY || 10;

    doc.text(
      `Total Price: ${totalSum.toFixed(2)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );
    doc.text(
      `Total Paid: ${totalPaid.toFixed(2)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 20,
      { align: "right" }
    );
    doc.text(
      `Total Balance: ${totalUnpaid.toFixed(2)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 30,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const customerName = selectedCustomer
      ? selectedCustomer.fullName
      : "AllCustomers";
    const statusName = selectedStatus || "AllStatus";
    const balanceName = totalUnpaid.toFixed(2);

    const filename = `${customerName}_${statusName}_${balanceName}_Sales-report_${timestamp}.pdf`;
    doc.save(filename);
    handleMenuClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const clearFilters = () => {
    setSelectedCustomer(null);
    setSelectedStatus("");
    setFilteredOrders([]);
    setTotals({ ...totals, isClick: true });
    setPage(1);
    setLimit(15);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };

  const visibleColumns = headCells.filter((cell) => cell.isVisible);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const handlePageChange = (event, newPage) => {
    setTotals({ ...totals, isClick: true });
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Sales Report
          </Typography>
          <Box display="flex" justifyContent="start" gap={2} m={1}>
            <Autocomplete
              options={customers}
              sx={{ width: "20%" }}
              disableClearable
              value={selectedCustomer}
              getOptionLabel={(option) => `${option.fullName}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Customer"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              onChange={(event, value) => handleCustomerChange(value)}
            />
            <TextField
              id="outlined-select-status"
              select
              label="Filter By Status"
              sx={{ width: "20%" }}
              value={selectedStatus}
              onChange={handleStatusChange}
            >
              {statues().map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <Box display="flex" justifyContent="end" gap={2} m={1}>
              <Button
                variant="contained"
                onClick={clearFilters}
                startIcon={<ClearAllIcon />}
                sx={{
                  backgroundColor: "rgba(244,151,3,.8)",
                  color: "rgb(20,61,89)",
                  "&:hover": {
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)", // Darker on hover
                  },
                }}
              >
                Clear
              </Button>
              <div>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)", // Darker on hover
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </div>
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid
              item
              xs={hiddenColumns.length > 0 ? 9 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    {filteredOrders.length !== 0 ? (
                      <OrderProductsFilter options={filteredOrders} />
                    ) : (
                      <Table>
                        <TableHead>
                          <TableRow>
                            {visibleColumns.map((headCell) => (
                              <TableCell
                                className={
                                  headCell.isVisible
                                    ? "table-cell-visible"
                                    : "table-cell-hidden"
                                }
                                key={headCell.id}
                                style={{
                                  width: headCell.isVisible ? "auto" : "0",
                                }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "transparent",
                                    "& .MuiSvgIcon-root": {
                                      backgroundColor: "transparent !important",
                                    },
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography variant="subtitle1" noWrap>
                                    {headCell.label}
                                  </Typography>
                                  <Checkbox
                                    checked={headCell.isVisible}
                                    onChange={() =>
                                      handleColumnToggle(headCell.id)
                                    }
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CancelIcon />}
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        backgroundColor:
                                          "transparent !important", // Remove background color from Checkbox icon
                                      },
                                    }}
                                  />
                                </Box>
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {recordsAfterSortingAndFiltering().length > 0 ? (
                            recordsAfterSortingAndFiltering().map((item) => (
                              <TableRow key={item.id}>
                                {visibleColumns.map((headCell) => (
                                  <TableCell key={headCell.id}>
                                    {headCell.id === "customer"
                                      ? item.customer.fullName
                                      : headCell.id === "quantity"
                                      ? item.orderProducts.length
                                      : headCell.id === "totalPrice"
                                      ? formatNumber(
                                          calculateTotalPrice(
                                            item.orderProducts
                                          )
                                        )
                                      : headCell.id === "paid"
                                      ? formatNumber(item.paid)
                                      : headCell.id === "unpaid"
                                      ? formatNumber(
                                          calculateTotalPrice(
                                            item.orderProducts
                                          ) - item.paid
                                        )
                                      : headCell.id === "date"
                                      ? new Date(
                                          item.createdAt
                                        ).toLocaleString()
                                      : headCell.id === "status"
                                      ? item.status
                                      : null}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))
                          ) : (
                            <Norecords col={6} />
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TblContainer>

                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {orders.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || orders.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={orders.length === 0}
                      />
                    )}
                  </Box>
                </Paper>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  flexDirection: "column",
                  p: 1,
                  gap: 1,
                  m: 1,
                  bgcolor: "background.paper",
                  borderRadius: 1,
                }}
              >
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Price: {formatNumber(totals.totalPrice)}
                </div>
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Paid:{" "}
                  {totals.isClick
                    ? formatNumber(totals.totalPaid)
                    : formatNumber(calculateTotalPaid(orders))}
                </div>
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Balance:{" "}
                  {totals.isClick
                    ? formatNumber(totals.totalBalance)
                    : formatNumber(
                        calculateTotalSumOrderProducts(orders) -
                          calculateTotalPaid(orders)
                      )}
                </div>
              </Box>
            </Grid>
            {hiddenColumns.length > 0 && (
              <Grid item xs={2} className="card__body" sx={{ marginLeft: 10 }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent", // Remove background color
                            },
                          }}
                          checked={!headCell.isVisible}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1, // Adjust marginBottom
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0, // Override default label margin-top
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default SalesReport;
